import { render, staticRenderFns } from "./cross-sell-ctas.vue?vue&type=template&id=14c1b80b&scoped=true&lang=pug&"
import script from "./cross-sell-ctas.vue?vue&type=script&lang=js&"
export * from "./cross-sell-ctas.vue?vue&type=script&lang=js&"
import style0 from "./cross-sell-ctas.vue?vue&type=style&index=0&id=14c1b80b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c1b80b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsCtaItem: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/products/cta/item.vue').default})
